
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...file_name]",
      function () {
        return require("private-next-pages/[...file_name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...file_name]"])
      });
    }
  